import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "item-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title mb-1 mt-4" }, "Conditions of this authority", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " 1. I confirm that the direct debit information supplied by me is connected to a bank account which I can operate and have individual authority over; ", -1)
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " 3. I confirm that this authority its subject to my bank’s terms and conditions that relate to my account; ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " 4. I agree to receive confirmation of the sign up to direct debits (within 5 business days) and notifications for ongoing payments to the email address provided; ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " 5. I authorise Booster Assurance Limited, using authorisation number 0232318 to initiate direct debits and deduct my next and all subsequent insurance payments from this account on the agreed day of each month. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", _hoisted_4, [
      _createTextVNode(" 2. I confirm that I have read and accept the "),
      (_ctx.usesGenericWording)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " specific conditions relating to notices and disputes"))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, " Direct Debit Terms and Conditions"))
    ]),
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
}